module.exports = __webpack_public_path__ + "img/container-3.f8729861.png";